import React from 'react';

export default () => {
  return (
    <div className="step row">
      {/*Pregunta 13*/}
      <div className="col-md-12">
        <h3>13. En general, ¿tengo una opinión buena de mi?</h3>
        <ul className="data-list-2" id="preg13">
          <li>
            <input
              name="preg13"
              type="radio"
              className="required check_radio"
              value="2"
            />
            <label>Totalmente De acuerdo</label>
          </li>
          <li>
            <input
              name="preg13"
              type="radio"
              className="required check_radio"
              value="1"
            />
            <label>De acuerdo</label>
          </li>
          <li>
            <input
              name="preg13"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Ni de acuerdo ni en desacuerdo</label>
          </li>
          <li>
            <input
              name="preg13"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>En desacuerdo</label>
          </li>
          <li>
            <input
              name="preg13"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Totalmente desacuerdo</label>
          </li>
        </ul>
      </div>
      {/*Pregunta 14*/}
      <div className="col-md-12">
        <h3>14. ¿Siento que mi trabajo es importante?</h3>
        <ul className="data-list-2" id="preg14">
          <li>
            <input
              name="preg14"
              type="radio"
              className="required check_radio"
              value="2"
            />
            <label>Totalmente De acuerdo</label>
          </li>
          <li>
            <input
              name="preg14"
              type="radio"
              className="required check_radio"
              value="1"
            />
            <label>De acuerdo</label>
          </li>
          <li>
            <input
              name="preg14"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Ni de acuerdo ni en desacuerdo</label>
          </li>
          <li>
            <input
              name="preg14"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>En desacuerdo</label>
          </li>
          <li>
            <input
              name="preg14"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Totalmente desacuerdo</label>
          </li>
        </ul>
      </div>
      {/*Pregunta 15*/}
      <div className="col-md-12">
        <h3>
          15. ¿Entiendo claramente cómo mi rol contribuye a logro de los
          objetivos y metas de la empresa?
        </h3>
        <ul className="data-list-2" id="preg15">
          <li>
            <input
              name="preg15"
              type="radio"
              className="required check_radio"
              value="2"
            />
            <label>Totalmente De acuerdo</label>
          </li>
          <li>
            <input
              name="preg15"
              type="radio"
              className="required check_radio"
              value="1"
            />
            <label>De acuerdo</label>
          </li>
          <li>
            <input
              name="preg15"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Ni de acuerdo ni en desacuerdo</label>
          </li>
          <li>
            <input
              name="preg15"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>En desacuerdo</label>
          </li>
          <li>
            <input
              name="preg15"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Totalmente desacuerdo</label>
          </li>
        </ul>
      </div>
      {/*Pregunta 16*/}
      <div className="col-md-12">
        <h3>16. ¿Estoy satisfecho(a) con mi trabajo?</h3>
        <ul className="data-list-2" id="preg16">
          <li>
            <input
              name="preg16"
              type="radio"
              className="required check_radio"
              value="2"
            />
            <label>Totalmente De acuerdo</label>
          </li>
          <li>
            <input
              name="preg16"
              type="radio"
              className="required check_radio"
              value="1"
            />
            <label>De acuerdo</label>
          </li>
          <li>
            <input
              name="preg16"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Ni de acuerdo ni en desacuerdo</label>
          </li>
          <li>
            <input
              name="preg16"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>En desacuerdo</label>
          </li>
          <li>
            <input
              name="preg16"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Totalmente desacuerdo</label>
          </li>
        </ul>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pages/survey/questions/Step4.jsx